// extracted by mini-css-extract-plugin
export var container = "blankLayout-module--container--c662d";